class SvgIconBuilder {
    static textPlaceholder = '%text%'; // Do not use regex reserved characters in placeholders
    static fgColourPlaceholder = '%fgColour%';
    static bgColourPlaceholder = '%bgColour%';
    static coral = '#F04D3E';
    static lightCoral = '#EC9D9D';
    static darkGreen = '#137e02';
    static lightGrey = '#E0E1E2';
    static white = '#FFFFFF';
    static black = '#000000';
    static seconds15Min = 15 * 60;
    static seconds30Min = 30 * 60;
    static seconds45Min = 45 * 60;
    static seconds60Min = 60 * 60;
    svgXml;
    constructor(widthInPx, heightInPx, viewBoxWidth, viewBoxHeight) {
        this.svgXml = '<?xml version="1.0" encoding="utf-8"?>' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ' +
            'x="0px" y="0px" width="' + widthInPx + 'px" height="' + heightInPx + 'px" ' +
            'viewBox="0 0 ' + viewBoxWidth + ' ' + viewBoxHeight + '" ' +
            'style="enable-background:new 0 0 ' + viewBoxWidth + ' ' + viewBoxHeight + ';" ' +
            'xml:space="preserve">';
    }
    appendLayer(layer) {
        this.svgXml += layer;
        return this;
    }
    ;
    appendColoured(layer, fgColour, bgColour) {
        const layerXml = layer.replace(new RegExp(SvgIconBuilder.fgColourPlaceholder, 'g'), fgColour);
        this.svgXml += layerXml.replace(new RegExp(SvgIconBuilder.bgColourPlaceholder, 'g'), bgColour);
        return this;
    }
    ;
    appendTextLayer(layer, text) {
        this.svgXml += layer.replace(SvgIconBuilder.textPlaceholder, text);
        return this;
    }
    ;
    appendColouredLayerIf(condition, layer, fgColour, bgColour) {
        if (condition) {
            this.appendColoured(layer, fgColour, bgColour);
        }
        return this;
    }
    ;
    appendTextLayerIf(condition, layer, text) {
        if (condition) {
            this.appendTextLayer(layer, text);
        }
        return this;
    }
    ;
    appendLayerIf(condition, layer) {
        if (condition) {
            this.svgXml += layer;
        }
        return this;
    }
    ;
    build() {
        this.svgXml += '</svg>';
        return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(this.svgXml);
    }
    ;
}
export default SvgIconBuilder;
